// extracted by mini-css-extract-plugin
export var mediaElement = "mockup-iphone-module--mediaElement--63db0";
export var mockImage = "mockup-iphone-module--mockImage--4c8b2";
export var mockup = "mockup-iphone-module--mockup--81b6a";